import React, { Fragment, useEffect, useState } from 'react';
import { Button, Col, Container, Input, Row, Table } from 'reactstrap';
import { toast } from "react-toastify";
import _ from 'lodash';
import { FilterSelect, ServiceThreadSpinner } from '.';
import { api, filterHelpers } from '../utils';
import { confirmAlert } from "react-confirm-alert";

export default function ManageScheduleReasons() {
   const ALL_OPT = { value: 0, label: "-- Select --", active: false };
   const CHILD_OPT = { value: 0, label: "-- Select --", active: false, parent: 0};
   const CHILD_MODEL = { id: 0, parentId: 0, name: "", active: true };
   const SCHED_MODEL = { id: 0, name: "", active: true };
   const [childList, setChildList] = useState([]); // child problems unfiltered
   const [childSubs, setChildSubs] = useState([]); // child problems filtered by parent reason id
   const [childReason, setChildReason] = useState(CHILD_MODEL);
   const [reasonList, setReasonList] = useState([]);
   const [schedReason, setSchedReason] = useState(SCHED_MODEL);
   const [filters, setFilters] = useState([
      { filterName: "reason", value: ALL_OPT },
      { filterName: "child", value: CHILD_OPT }
   ]);
   const [editReason, setEditReason] = useState("");
   const [editSub, setEditSub] = useState("");
   const [newReason, setNewReason] = useState("");
   const [newSub, setNewSub] = useState("");
   const [origReason, setOrigReason] = useState("");
   const [origSub, setOrigSub] = useState("");
   const [spinReason, setSpinReason] = useState(true);


   useEffect(() => {
      runQuery();
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [])

   useEffect(() => {
      if (!childReason || childReason.id === 0)
         return; // child was reset to initial state

      if (!editSub || editSub.length < 1)
         return; // Not editing       

      if (childReason.name === origSub)
         return; // No change made to child being edited

      if (childReason.name.length < 3) { // Do we need this?
         toast.error("Child problem must be at least 3 characters");
         return;
      }
      UpdateSubReason();
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [childReason])

   useEffect(() => {
      if (!schedReason || schedReason.id === 0)
         return; // reason was reset to initial state

      if (!editReason || editReason.length < 1)
         return; // Not editing       

      if (schedReason.name === origReason)
         return; // No change made to reason being edited

      if (schedReason.name.length < 3) { // Do we need this?
         toast.error("Schedule reason must be at least 3 characters");
         return;
      }
      UpdateReason();
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [schedReason])

   function ActivateReason() {
      if (!schedReason || schedReason.id === 0) {
         toast.error("Please select a reason to activate");
         return;
      }

      setSpinReason(true);
      api.post(`Production/ActivateScheduleReason/${schedReason.id}`)
         .then((response) => {
            if (response.data.success) {
               toast.success("Reason activated!")
               runQuery();
            } else {
               toast.error(response.data.message);
               setSpinReason(false);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
            setSpinReason(false);
         });
   }

   function ActivateSubReason() {
      if (!childReason || childReason.id === 0) {
         toast.error("Please select a child problem to activate");
         return;
      }

      setSpinReason(true);
      api.post(`Production/ActivateScheduleSubReason/${childReason.id}`)
         .then((response) => {
            if (response.data.success) {
               toast.success("Child problem activated!")
               runQuery();
            } else {
               toast.error(response.data.message);
               setSpinReason(false);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
            setSpinReason(false);
         });
   }

   function DeleteReason() {
      setSpinReason(true);
      api.post(`Production/DeleteScheduleReason/${schedReason.id}`)
         .then((response) => {
            if (response.data.success) {
               toast.success("Reason was successfully deleted or made inactive!")
               runQuery();
            } else {
               toast.error(response.data.message);
               setSpinReason(false);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
            setSpinReason(false);
         });
   }

   function DeleteSubReason() {
      setSpinReason(true);
      api.post(`Production/DeleteScheduleSubReason/${childReason.id}`)
         .then((response) => {
            if (response.data.success) {
               toast.success("Child problem was successfully deleted or made inactive!")
               runQuery();
            } else {
               toast.error(response.data.message);
               setSpinReason(false);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
            setSpinReason(false);
         });
   }

   const fixChildren = async (id) => {
      let newPblmList = [CHILD_OPT]; // Default option
      var subs = _.pickBy(childList, (e) => _.includes([id], e.parent));
      if (subs) { // There are child problems for the selected reason code
         newPblmList = _.concat(
            [CHILD_OPT],
            _.map(subs, (s) => ({ value: s.value, label: s.label, active: s.active, parent: s.parent, isSystem: s.isSystem }))
         );
         setChildSubs(newPblmList);
      }
   };

   async function onReasonChange(newFilterValue) {
      // Populate selected reason children & clear lingering values
      await fixChildren(newFilterValue.value);
      setChildReason(CHILD_MODEL);
      setOrigSub("");
      setEditSub("");
      setNewSub("")
      setNewReason("");

      // Set the filters to the selected reason and the default child
      let newFilters = filterHelpers.getFilters(filters, newFilterValue);
      newFilters = filterHelpers.getFilters(newFilters, {
         filterName: "child",
         value: CHILD_OPT,
      });
      setFilters(newFilters);

      if (newFilterValue.value === 0) { // Clear edit info
         setSchedReason(SCHED_MODEL);
         setOrigReason("");
         setEditReason("");
      }
      else { // Get the reason to be edited
         const d = _.find(reasonList, (x) => x.value === newFilterValue.value);
         setOrigReason(d.label);
         setEditReason(d.label);

         let changes = Object.assign({}, schedReason);
         changes.id = d.value;
         changes.name = d.label;
         changes.active = d.active;
         changes.isSystem = d.isSystem;
         setSchedReason(changes);
      }
   }

   function onReasonUpdate() {
      let changes = Object.assign({}, schedReason);
      changes.name = editReason
      setSchedReason(changes);
   }

   function onReasonSubUpdate() {
      let changes = Object.assign({}, childReason);
      changes.name = editSub
      setChildReason(changes);
   }

   function onSubChange(newFilterValue) {
      let newFilters = filterHelpers.getFilters(filters, newFilterValue);
      setFilters(newFilters);

      setNewSub("")
      if (newFilterValue.value === 0) { // Clear edit info
         setChildReason(CHILD_MODEL);
         setOrigSub("");
         setEditSub("");
      }
      else { // Get the child to be edited
         const pblm = _.find(childSubs, (x) => x.value === newFilterValue.value);
         setOrigSub(pblm.label);
         setEditSub(pblm.label);

         let changes = Object.assign({}, CHILD_MODEL);
         changes.id = pblm.value;
         changes.name = pblm.label;
         changes.active = pblm.active;
         changes.parentId = pblm.parent;
         changes.isSystem = pblm.isSystem;
         setChildReason(changes);
      }
   }

   function runQuery() {
      setSpinReason(true);
      api
         .fetch(`Production/LoadAllScheduleReasons`)
         .then((response) => {
            if (response.data.success) {
               const srList = _.concat([ALL_OPT],
                  _.map(response.data.reasons, (r) => ({
                     value: r.id,
                     label: r.name,
                     active: r.active,
                     isSystem: r.isSystem
                  })));
               const subList = _.concat(
                  _.map(response.data.childReasons, (rSub) => ({
                     value: rSub.id,
                     label: rSub.name,
                     parent: rSub.parentId,
                     active: rSub.active,
                     isSystem: rSub.isSystem
                  }))
               );
               return {
                  srList: srList,
                  subList: subList
               };
            } else {
               throw new Error(response);
            }
         })
         .then(({ srList, subList }) => {
            setReasonList(srList);
            setChildList(subList);
            setChildSubs(CHILD_OPT); // This will populate when a parent reason is chosen
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
         })
         .finally(() => {
            setEditReason("");
            setOrigReason("");
            setNewReason("")
            setEditSub("");
            setOrigSub("");
            setNewSub("")
            setSchedReason(SCHED_MODEL);
            setChildReason(CHILD_MODEL);
            setSpinReason(false);
         });
   }

   function SaveNewReason() {
      if (!newReason || newReason.length < 1) {
         toast.error("Please provide a reason description");
         return;
      }
      if (newReason.length < 3) {
         toast.error("Reason description must be at least 3 characters");
         return;
      }
      let payload = SCHED_MODEL;
      payload.name = newReason;

      setSpinReason(true);
      api.post('Production/SaveScheduleReason', payload)
         .then((response) => {
            if (response.data.success) {
               toast.success("Reason created!")
               runQuery();
            } else {
               toast.error(response.data.message);
               setSpinReason(false);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
            setSpinReason(false);
         });
   }

   function SaveNewSubReason() {
      if (!newSub || newSub.length < 1) {
         toast.error("Please provide a child problem description");
         return;
      }
      if (newSub.length < 3) {
         toast.error("Child problem description must be at least 3 characters");
         return;
      }
      let payload = CHILD_MODEL;
      payload.name = newSub;
      payload.parentId = schedReason.id;

      setSpinReason(true);
      api.post('Production/SaveScheduleSubReason', payload)
         .then((response) => {
            if (response.data.success) {
               toast.success("Child Problem created!")
               runQuery();
            } else {
               toast.error(response.data.message);
               setSpinReason(false);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
            setSpinReason(false);
         });
   }

   function UpdateReason() {
      setSpinReason(true);
      api.post('Production/SaveScheduleReason', schedReason)
         .then((response) => {
            if (response.data.success) {
               toast.success("Reason updated!")
               runQuery();
            } else {
               toast.error(response.data.message);
               setSpinReason(false);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
            setSpinReason(false);
         });
   }

   function UpdateSubReason() {
      setSpinReason(true);
      api.post('Production/SaveScheduleSubReason', childReason)
         .then((response) => {
            if (response.data.success) {
               toast.success("Child problem updated!")
               runQuery();
            } else {
               toast.error(response.data.message);
               setSpinReason(false);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
            setSpinReason(false);
         });
   }

   const ShowDeleteModal = () => {
      if (!schedReason || schedReason.id === 0) {
         toast.error("Please select a reason");
         return;
      }
      confirmAlert({
         title: "Confirm Deletion",
         message: `Are you sure you want to delete the ${editReason} reason?`,
         buttons: [
            { label: "Yes", onClick: () => { DeleteReason() } },
            { label: "No" }
         ]
      });
   }

   const ShowDeleteSubModal = () => {
      if (!childReason || childReason.id === 0) {
         toast.error("Please select a child problem");
         return;
      }
      confirmAlert({
         title: "Confirm Deletion",
         message: `Are you sure you want to delete the ${editSub} problem of the selected ${schedReason.name} reason?`,
         buttons: [
            { label: "Yes", onClick: () => { DeleteSubReason() } },
            { label: "No" }
         ]
      });
   }

   return (
      <Container fluid>
         <Row>
            <Col>
               <Fragment>
                  <ServiceThreadSpinner on={spinReason}>
                     <Row className="px-2 py-2">
                        <Col xxl={{ offset: 0, size: 12 }}>
                           <Table className="transparent-background my-0">
                              <tbody>
                                 <tr>
                                    <td className="transparent-background data-cell noWrap h6" width="120px">
                                       New Reason:
                                    </td>
                                    <td className="transparent-background" width="500px">
                                       <Input
                                          type="text"
                                          value={newReason || ""}
                                          onChange={(e) => setNewReason(e.target.value)}
                                          maxLength="100"
                                       />
                                    </td>
                                    <td className="transparent-background">
                                       <Button
                                          title="New Reason"
                                          className="shredButtonExcel ms-2"
                                          onClick={() => SaveNewReason()}
                                       >
                                          Add New Reason
                                       </Button>
                                    </td>
                                 </tr>
                              </tbody>
                           </Table>
                        </Col>
                     </Row>

                     <Row className="px-2 py-2">
                        <Col xxl={{ offset: 0, size: 12 }}>
                           {reasonList && reasonList.length ? (
                              <Table className="transparent-background my-0">
                                 <tbody>
                                    <tr>
                                       <td className="transparent-background data-cell noWrap h6" width="120px">
                                          Edit Reason:
                                       </td>
                                       <td className="transparent-background" width="500px">
                                          <FilterSelect
                                             filterName="reason"
                                             options={reasonList}
                                             value={filterHelpers.getValue(filters, "reason")}
                                             onChangeCallback={e => onReasonChange(e)}
                                          />
                                       </td>
                                       <td className="transparent-background"></td>
                                    </tr>
                                 </tbody>
                              </Table>
                           ) : null}
                        </Col>
                     </Row>

                     {schedReason && schedReason.id > 0 ? (
                        <div>
                           <Row className="px-0 py-0">
                              <Table className="transparent-background data-table">
                                 <tbody>
                                    <tr>
                                       <td className="transparent-background data-cell width40px"></td>
                                       <td colSpan={5} className="transparent-background data-cell noWrap h6">
                                          Deleting a reason that has production schedule records attached will set it to inactive.
                                       </td>
                                    </tr>
                                    <tr>
                                       <td className="transparent-background data-cell width40px"></td>
                                       <td colSpan={5} className="transparent-background data-cell noWrap h6">
                                          Inactive reasons will not show up in production scheduling when changing or deleting a schedule.
                                       </td>
                                    </tr>
                                    <tr>
                                       <td className="transparent-background data-cell width40px"></td>
                                       <td className="transparent-background data-cell width95px noWrap h6">
                                          Id: {schedReason.id}
                                       </td>
                                       <td className="transparent-background data-cell noWrap h6 width115px">
                                          Active: {schedReason.active ? "Yes" : "No"}
                                       </td>
                                       <td colSpan={3} className="transparent-background data-cell"></td>
                                    </tr>
                                    {schedReason.isSystem ? (
                                       <tr>
                                          <td className="transparent-background data-cell width40px"></td>
                                          <td colSpan={5} className="transparent-background data-cell noWrap h6">
                                             System reason — managed by the auto-scheduler (read-only).
                                          </td>
                                       </tr>
                                    ) : null}
                                    <tr>
                                       <td className="transparent-background data-cell width40px"></td>
                                       <td className="transparent-background data-cell noWrap h6 width115px">
                                          Reason:
                                       </td>
                                       <td className="transparent-background data-cell width500px">
                                          <Input
                                             type="text"
                                             value={editReason || ""}
                                             onChange={(e) => setEditReason(e.target.value)}
                                             maxLength="100"
                                             readOnly={schedReason.isSystem}
                                          />
                                       </td>
                                       {schedReason.isSystem ? (
                                          <td colSpan={2} className="transparent-background data-cell"></td>
                                       ) : (
                                          <Fragment>
                                             <td className="transparent-background data-cell width115px">
                                                <Button
                                                   title="Update"
                                                   className="shredButton"
                                                   onClick={() => onReasonUpdate()}
                                                >
                                                   Update
                                                </Button>
                                             </td>
                                             <td className="transparent-background data-cell width115px">
                                                <Button
                                                   title="Delete"
                                                   className="shredButton"
                                                   onClick={() => ShowDeleteModal()}
                                                >
                                                   Delete
                                                </Button>
                                             </td>
                                          </Fragment>
                                       )}
                                       {!schedReason.active && !schedReason.isSystem ? (
                                          <td className="transparent-background data-cell">
                                             <Button
                                                title="Reactivate"
                                                className="shredButton"
                                                onClick={() => ActivateReason()}
                                             >
                                                Reactivate
                                             </Button>
                                          </td>
                                       ) : <td className="transparent-background data-cell"></td>}
                                    </tr>
                                 </tbody>
                              </Table>
                           </Row>

                           {schedReason.active && !schedReason.isSystem ? (
                              <div>
                                 <br />
                                 <hr />
                                 <Row className="px-2 py-2">
                                    <Col xxl={{ offset: 0, size: 12 }} className="noWrap h4">
                                       Manage Problem Children for the selected {schedReason.name} Reason
                                    </Col>
                                 </Row>
                                 <Row className="px-2 py-2">
                                    <Col xxl={{ offset: 0, size: 12 }}>
                                       <Table className="transparent-background my-0">
                                          <tbody>
                                             <tr>
                                                <td className="transparent-background data-cell noWrap h6" width="120px">
                                                   New Problem:
                                                </td>
                                                <td className="transparent-background" width="500px">
                                                   <Input
                                                      type="text"
                                                      value={newSub || ""}
                                                      onChange={(e) => setNewSub(e.target.value)}
                                                      maxLength="100"
                                                   />
                                                </td>
                                                <td className="transparent-background">
                                                   <Button
                                                      title="New Problem"
                                                      className="shredButtonExcel ms-2"
                                                      onClick={() => SaveNewSubReason()}
                                                   >
                                                      Add New Problem
                                                   </Button>
                                                </td>
                                             </tr>
                                          </tbody>
                                       </Table>
                                    </Col>
                                 </Row>

                                 <Row className="px-2 py-2">
                                    <Col xxl={{ offset: 0, size: 12 }}>
                                       {childSubs && childSubs.length ? (
                                          <Table className="transparent-background my-0">
                                             <tbody>
                                                <tr>
                                                   <td className="transparent-background data-cell noWrap h6" width="120px">
                                                      Edit Problem:
                                                   </td>
                                                   <td className="transparent-background" width="500px">
                                                      <FilterSelect
                                                         filterName="child"
                                                         options={childSubs}
                                                         value={filterHelpers.getValue(filters, "child")}
                                                         onChangeCallback={e => onSubChange(e)}
                                                      />
                                                   </td>
                                                   <td className="transparent-background"></td>
                                                </tr>
                                             </tbody>
                                          </Table>
                                       ) : null}
                                    </Col>
                                 </Row>

                                 {childReason && childReason.id > 0 ? (
                                    <div>
                                       <Row className="px-0 py-0">
                                          <Table className="transparent-background data-table">
                                             <tbody>
                                                <tr>
                                                   <td className="transparent-background data-cell width40px"></td>
                                                   <td colSpan={5} className="transparent-background data-cell noWrap h6">
                                                      Deleting a problem that has production schedule records attached will set it to inactive.
                                                   </td>
                                                </tr>
                                                <tr>
                                                   <td className="transparent-background data-cell width40px"></td>
                                                   <td colSpan={5} className="transparent-background data-cell noWrap h6">
                                                      Inactive problems will not show up in production scheduling when changing or deleting a schedule.
                                                   </td>
                                                </tr>
                                                <tr>
                                                   <td className="transparent-background data-cell width40px"></td>
                                                   <td className="transparent-background data-cell width95px noWrap h6">
                                                      Id: {childReason.id}
                                                   </td>
                                                   <td className="transparent-background data-cell noWrap h6 width115px">
                                                      Active: {childReason.active ? "Yes" : "No"}
                                                   </td>
                                                   <td colSpan={3} className="transparent-background data-cell"></td>
                                                </tr>
                                                {childReason.isSystem ? (
                                                   <tr>
                                                      <td className="transparent-background data-cell width40px"></td>
                                                      <td colSpan={5} className="transparent-background data-cell noWrap h6">
                                                         System problem — managed by the auto-scheduler (read-only).
                                                      </td>
                                                   </tr>
                                                ) : null}
                                                <tr>
                                                   <td className="transparent-background data-cell width40px"></td>
                                                   <td className="transparent-background data-cell noWrap h6 width115px">
                                                      Problem:
                                                   </td>
                                                   <td className="transparent-background data-cell width500px">
                                                      <Input
                                                         type="text"
                                                         value={editSub || ""}
                                                         onChange={(e) => setEditSub(e.target.value)}
                                                         maxLength="100"
                                                         readOnly={childReason.isSystem}
                                                      />
                                                   </td>
                                                   {childReason.isSystem ? (
                                                      <td colSpan={2} className="transparent-background data-cell"></td>
                                                   ) : (
                                                      <Fragment>
                                                         <td className="transparent-background data-cell width115px">
                                                            <Button
                                                               title="Update"
                                                               className="shredButton"
                                                               onClick={() => onReasonSubUpdate()}
                                                            >
                                                               Update
                                                            </Button>
                                                         </td>
                                                         <td className="transparent-background data-cell width115px">
                                                            <Button
                                                               title="Delete"
                                                               className="shredButton"
                                                               onClick={() => ShowDeleteSubModal()}
                                                            >
                                                               Delete
                                                            </Button>
                                                         </td>
                                                      </Fragment>
                                                   )}
                                                   {!childReason.active && !childReason.isSystem ? (
                                                      <td className="transparent-background data-cell">
                                                         <Button
                                                            title="Reactivate"
                                                            className="shredButton"
                                                            onClick={() => ActivateSubReason()}
                                                         >
                                                            Reactivate
                                                         </Button>
                                                      </td>
                                                   ) : <td className="transparent-background data-cell"></td>}
                                                </tr>
                                             </tbody>
                                          </Table>
                                       </Row>
                                    </div>
                                 ) : null}
                              </div>
                           ) : null}
                        </div>
                     ) : null}

                  </ServiceThreadSpinner>
               </Fragment>
            </Col>
         </Row>
      </Container>
   );
}
